import React from "react";

const Clock = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 76C59.8823 76 76 59.8823 76 40C76 20.1177 59.8823 4 40 4C20.1177 4 4 20.1177 4 40C4 59.8823 20.1177 76 40 76ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
      fill="#FF6C92"
    />
    <path
      d="M42 10C42 11.1046 41.1046 12 40 12C38.8954 12 38 11.1046 38 10C38 8.89543 38.8954 8 40 8C41.1046 8 42 8.89543 42 10Z"
      fill="#FF6C92"
    />
    <path
      d="M42 70C42 71.1046 41.1046 72 40 72C38.8954 72 38 71.1046 38 70C38 68.8954 38.8954 68 40 68C41.1046 68 42 68.8954 42 70Z"
      fill="#FF6C92"
    />
    <path
      d="M72 40C72 41.1046 71.1046 42 70 42C68.8954 42 68 41.1046 68 40C68 38.8954 68.8954 38 70 38C71.1046 38 72 38.8954 72 40Z"
      fill="#FF6C92"
    />
    <path
      d="M12 40C12 41.1046 11.1046 42 10 42C8.89543 42 8 41.1046 8 40C8 38.8954 8.89543 38 10 38C11.1046 38 12 38.8954 12 40Z"
      fill="#FF6C92"
    />
    <path
      d="M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z"
      fill="#FF6C92"
    />
    <path
      d="M63 19C63 20.1046 62.1046 21 61 21C59.8954 21 59 20.1046 59 19C59 17.8954 59.8954 17 61 17C62.1046 17 63 17.8954 63 19Z"
      fill="#FF6C92"
    />
    <path
      d="M21 61C21 62.1046 20.1046 63 19 63C17.8954 63 17 62.1046 17 61C17 59.8954 17.8954 59 19 59C20.1046 59 21 59.8954 21 61Z"
      fill="#FF6C92"
    />
    <path
      d="M40 24C41.1046 24 42 24.8954 42 26V39.1715L62.4558 59.6274C63.2369 60.4084 63.2369 61.6747 62.4558 62.4558C61.6748 63.2368 60.4085 63.2368 59.6274 62.4558L38.5768 41.4052C38.2201 41.044 38 40.5477 38 40V26C38 24.8954 38.8954 24 40 24Z"
      fill="#FF6C92"
    />
  </svg>
);

export default Clock;
